module.exports = __webpack_public_path__ + "img/jt.98bc078f.png";